import {
  AiAssistantJSONChatMessageType,
  AiAssistantSubmissionChatMessage,
  PayrollSubmissionResponse,
} from "types/aiAssistant";

export const isPayrollSubmissionResponse = (
  message: AiAssistantSubmissionChatMessage,
): message is PayrollSubmissionResponse => {
  return message.type === AiAssistantJSONChatMessageType.SUBMIT_PAYROLL;
};
